import { gql } from "graphql-request";

export const RoadmapFeaturesQuery = gql`
    query ($limit: Int, $skip: Int, $locale: String) {
        roadmapFeatureCollection(
            limit: $limit
            skip: $skip
            locale: $locale
            order: timeFrame_DESC
        ) {
            total
            items {
                title
                description {
                    json
                }
                status {
                    roadmapStatusNameExternal
                }
                appsCollection(limit: 5) {
                    items {
                        roadmapAppNameExternal
                        filterQueryParam
                    }
                }
                category {
                    queryParameter
                    roadmapCategoryNameExternal
                }
                timeFrame
                slug
                pid
            }
        }
        taxonomyRoadmapAppCollection(locale: $locale) {
            items {
                roadmapAppNameExternal
                filterQueryParam
            }
        }
        taxonomyRoadmapCategoryCollection(locale: $locale) {
            items {
                roadmapCategoryNameExternal
                queryParameter
            }
        }
        taxonomyRoadmapStatusCollection(locale: $locale) {
            items {
                roadmapStatusNameExternal
            }
        }
    }
`;
